export default __webpack_public_path__ + "static/media/spray.9dfc6cad.svg";